import React from "react";

export default class Site extends React.Component {

  public render(): React.ReactNode {
    return <div>Site</div>;
  }

}